import { jsx as _jsx } from "react/jsx-runtime";
import { Modal as BaseModal, } from '@mui/base/Modal/index.js';
import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Backdrop } from './components/Backdrop.js';
import { FadePropsAdapter } from './components/FadePropsAdapter.js';
import { ModalWrapper } from './components/ModalWrapper.js';
import { InternalModalContext } from './context.js';
import { modalTheme } from './theme.js';
const StyledModal = styled(BaseModal) `
  /** Prevents stacking context issues, see https://stackoverflow.com/a/11742116 */
  position: fixed;
  z-index: ${modalTheme.overlay.zIndex};
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Modal = ({ open, slots, onClose, wrapperPadding, children, ...rest }) => {
    const timeout = modalTheme.fadeDuration;
    const mergedSlots = {
        backdrop: Backdrop,
        ...slots,
    };
    const closeWithReason = useCallback((event, reason) => {
        onClose?.(event, reason);
    }, [onClose]);
    const internalContext = useMemo(() => ({ onClose: closeWithReason }), [closeWithReason]);
    return (_jsx(InternalModalContext.Provider, { value: internalContext, children: _jsx(StyledModal, { slots: mergedSlots, open: open, onClose: onClose, ...rest, children: _jsx(FadePropsAdapter, { in: open, timeout: timeout, children: _jsx(ModalWrapper, { wrapperPadding: wrapperPadding, children: children }) }) }) }));
};
